import React, {useEffect, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { TOPMENUDATA, TRANSLATION } from '../constants/state'
import { useWPMenuTree } from '../Accessibility/DisclosureNavigationMenu/useWPMenuTree';
import DisclosureNavigationMenu from '../Accessibility/DisclosureNavigationMenu/DisclosureNavigationMenu';




const mapStateToProps = (state, ownProps) => ({
    menuData: getData(state, TOPMENUDATA),
    translation: getData(state, TRANSLATION), 
})


const SiteNavigationAccess = ({
    menuData,
    translation
}) => {
    const [menuTree, changeMenuTree] = useWPMenuTree(menuData)

    return (
        <DisclosureNavigationMenu
            accessName='Main Navigation'
            menuTree={menuTree}
            translation={translation}
            onChangeMenuTree={changeMenuTree}
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SiteNavigationAccess)